import { render } from "./modal3.vue?vue&type=template&id=7dd1f2bc"
import script from "./modal3.vue?vue&type=script&lang=ts"
export * from "./modal3.vue?vue&type=script&lang=ts"
script.render = render

export default script